export default {
  SET_SYSTEM_MONITOR (state, data) {
    state.system_monitor = data
  },
}
